import { motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] },
  }),
};

export default function About() {
  return (
    <section id="about" className="relative border-b border-surface-2">
      <div className="mx-auto max-w-[1440px] px-6 md:px-16 py-28 md:py-40">
        <div className="grid grid-cols-12 gap-6 md:gap-10">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-80px" }}
            variants={fadeUp}
            className="col-span-12 md:col-span-3 text-[11px] uppercase tracking-[0.28em] text-brass"
          >
            <div className="tabular">02 —</div>
            <div className="mt-2">The Candidate</div>
          </motion.div>

          <div className="col-span-12 md:col-span-9">
            <motion.h2
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-80px" }}
              variants={fadeUp}
              className="font-serif-display font-light text-ivory text-4xl md:text-6xl lg:text-7xl leading-[1.02] tracking-[-0.02em]"
            >
              A practitioner of <span className="italic text-brass">predictable delivery</span>, offering the
              board what capital projects demand: <span className="italic">clarity, cadence, courage</span>.
            </motion.h2>

            <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16">
              <motion.p
                initial="hidden" whileInView="visible" viewport={{ once: true }}
                variants={fadeUp} custom={1}
                className="text-mutedfg text-lg leading-relaxed font-light"
              >
                Over two decades I have led planning and controls for integrated cement plants, steel manufacturing,
                power generation and waste-heat-recovery programs — from front-end loading through commissioning and
                statutory close-out. My work sits at the intersection of finance, engineering and governance.
              </motion.p>
              <motion.p
                initial="hidden" whileInView="visible" viewport={{ once: true }}
                variants={fadeUp} custom={2}
                className="text-mutedfg text-lg leading-relaxed font-light"
              >
                I now offer that discipline to listed boards — as an Independent Director attentive to CAPEX
                stewardship, risk, HSE, statutory readiness and the quiet arithmetic that separates a project
                that delivers from one that drifts. <span className="text-brass">Enquiries welcome across all sectors.</span>
              </motion.p>
            </div>

            <motion.div
              initial="hidden" whileInView="visible" viewport={{ once: true }}
              variants={fadeUp} custom={3}
              className="mt-16 flex flex-wrap items-center gap-8 text-[11px] uppercase tracking-[0.22em] text-ivory/70"
            >
              <span>Based in Udaipur, Rajasthan</span>
              <span className="h-3 w-px bg-brass/50" />
              <span>Executive MBA (Finance) · in progress</span>
              <span className="h-3 w-px bg-brass/50" />
              <span>Chartered Engineer · FIE</span>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
